import { mutex, handleTokenRefresh } from "./utils/authUtils";
import { QryptErrorCode } from "@libs/appliance_common";
import { logoutUser } from "./slices/authSlice";
import { fetchBaseQuery } from "@reduxjs/toolkit/query";
const createBaseQuery = (baseUrl)=>{
    const baseQuery = fetchBaseQuery({
        baseUrl,
        prepareHeaders: (headers, { getState })=>{
            const accessToken = getState().auth.accessToken;
            if (accessToken) {
                headers.set("authorization", `Bearer ${accessToken}`);
            }
            return headers;
        }
    });
    const customFetchBase = async (args, api, extraOptions)=>{
        // Wait for any ongoing refresh to complete
        await mutex.waitForUnlock();
        let result = await baseQuery(args, api, extraOptions);
        const url = typeof args === "string" ? args : args.url;
        const error_code = result.error?.data?.error_code;
        // bypass refresh if request is to token endpoint itself
        if ((error_code === QryptErrorCode.Forbidden || error_code === QryptErrorCode.Middleware) && url !== "api/admin/token") {
            let refreshed = false;
            // check if another request is already refreshing the token
            if (!mutex.isLocked()) {
                refreshed = await handleTokenRefresh(api);
            } else {
                // wait for the other request to finish and assume it was successful
                await mutex.waitForUnlock();
                refreshed = true;
            }
            if (refreshed) {
                // Retry the original request
                result = await baseQuery(args, api, extraOptions);
            }
        } else if (error_code === QryptErrorCode.SystemState) {
            // service unavailable (sealed or uninitialized)
            api.dispatch(logoutUser());
        }
        return result;
    };
    return customFetchBase;
};
export default createBaseQuery;
